import type { PaginationMetadata, PaginationQuery } from './common'
import type { StockBucket } from './stock'

export const STOCK_ADJUSTMENT_STATUSES = ['completed', 'cancelled'] as const
export type StockAdjustmentStatus = (typeof STOCK_ADJUSTMENT_STATUSES)[number]

export const STOCK_ADJUSTMENT_STATUS_LABELS: Record<
  StockAdjustmentStatus,
  { label: string; variant: 'default' | 'outline' | 'secondary' | 'destructive' }
> = {
  completed: { label: 'Selesai', variant: 'default' },
  cancelled: { label: 'Dibatalkan', variant: 'destructive' },
}

export interface StockAdjustment {
  id: string
  workspaceId: string
  code: string
  date: string
  itemType: 'raw_material' | 'product'
  itemId: string
  itemName: string
  itemSku: string | null
  uomId: string
  uomName: string
  bucket: StockBucket
  systemQty: number
  countedQty: number
  difference: number
  reasonId: string
  reasonName?: string
  costPerUnit: number
  note: string | null
  status: StockAdjustmentStatus
  cancelReason: string | null
  createdBy: string | null
  createdByName?: string | null
  createdAt: string
  updatedAt: string
}

export interface CreateStockAdjustmentReq {
  date?: string
  itemType: 'raw_material' | 'product'
  itemId: string
  bucket: StockBucket
  countedQty: number
  reasonId: string
  note?: string | null
}

export interface CancelStockAdjustmentReq {
  cancelReason: string
}

export interface GetStockAdjustmentListReq extends PaginationQuery {
  itemType?: 'raw_material' | 'product'
  status?: StockAdjustmentStatus
  search?: string
  startDate?: string
  endDate?: string
}

export interface StockAdjustmentListRes {
  items: StockAdjustment[]
  pagination: PaginationMetadata
}
